import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useLocation, useRouter } from '../utils/router/v3Bridge';
import usePostLoginHandler from './usePostLoginHandler';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { UIActions } from '../ui/uiSlice';

function getActionForError(error: string, platform: string) {
  const displayPlatform = _.capitalize(platform);

  switch (error) {
    case 'missing-integration':
      return UIActions.pushToast({
        level: 'error',
        message: `${displayPlatform} is not integrated`,
      });
    case 'missing-membership': {
      return UIActions.pushToast({
        level: 'error',
        message: `That user account does not belong to the connected ${displayPlatform} account`,
      });
    }
    case 'seat-limit-maxed':
      return UIActions.pushToast({
        level: 'error',
        message:
          'Your team has reached its seat limit. Please upgrade or contact support.',
      });
    case 'user-creation-disallowed':
      return UIActions.pushToast({
        level: 'error',
        message:
          'Oops, your team requires each new member to be invited into Slab. Please ask one of your teammates to invite you.',
      });
    case 'deactivated':
      return UIActions.pushToast({
        level: 'error',
        message: 'This account has been deactivated',
      });
    default:
      return UIActions.pushToast({
        level: 'error',
        message: 'Unknown login error. Please contact support.',
      });
  }
}

interface LoginHandlerProps {
  children: React.ReactNode;
}

const LoginHandler = ({ children }: LoginHandlerProps) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { pathname, query: { authToken, error, platform } = {} } =
    useLocation();
  const postLoginHandler = usePostLoginHandler();
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const [capturingToken, setCapturingToken] = useState(false);

  useEffect(() => {
    if (authToken) {
      setCapturingToken(true);
      postLoginHandler(authToken as string);
    } else if (error) {
      const action = getActionForError(error as string, platform as string);
      dispatch(action);
      router.replace(pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return capturingToken ? <div>Logging you in...</div> : <>{children}</>;
};

export default LoginHandler;
